{
  "battery": "Batteria",
  "depth": "Deptho",
  "device": "Dispositivo",
  "flow": "Fluire",
  "gps": "GPS",
  "hallSwitch": "Interruttore di sala",
  "hall_switch": "Interruttore di sala",
  "humidity": "Umidità",
  "icm": "Orientamento",
  "pressure": "Pressione",
  "pressureSwitch": "Interruttore di pressione",
  "pressure_switch": "Interruttore di pressione",
  "reel": "Bobina",
  "relay": "Staffetta",
  "temperature": "Temperatura",
  "vfd": "Variatore di frequenza",
  "wheel": "Ruota"
}
